<form class="login-form" [formGroup]="loginFormGrp">
  @if (errorMessage) {
    <div class="ml-0 error-container">
      {{'login.failed_msg' | translate}}
    </div>
  }
  <div class="row">
    <div class="col-sm-12 form-group">
      <h2>{{'login.log_in' | translate}}</h2>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12 form-group">
      <label for="username">
        <span>{{"login.user_name" | translate}}</span>
      </label>
      <input id="username" type="email" matInput class="uw-input" formControlName="username" [errorStateMatcher]="matcher" placeholder="">
      @if (loginFormGrp.get('username')?.hasError('email') && !loginFormGrp.get('username')?.hasError('required')) {
        <mat-error>
          {{ "common.please_enter_a_valid_email_address" | translate }}
        </mat-error>
      }
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12 form-group">
      <label for="password">
        <span>{{"login.password" | translate}}</span>
      </label>
      <input #password id="password" type="password" class="uw-input" matInput formControlName="password" [errorStateMatcher]="matcher">
      @if (loginFormGrp.get('password')?.dirty && loginFormGrp.get('password')?.hasError('required')) {
        <mat-error>
          {{ "common.password_is" | translate }}
        </mat-error>
      }
    </div>
  </div>

  <div class="row col-sm-12">
    <div>
      <input type="checkbox" (click)="showPassword(password)">
    </div>
    <div class="ml-2"> {{'common.show_password' | translate}} </div>
  </div>

  <div class="login-action-container">
    <uw-button [loading]="buttonLoading" [isMediumSize]="true" (buttonClick)="login()"  btnLabel="{{'login.log_in' | translate}}"></uw-button>
    <button mat-button [routerLink]="['/forgot-password']">{{"login.forgotPassword" | translate}}?</button>
  </div>
</form>

<uw-language-selector></uw-language-selector>
